/* ═══════════════════════════════════════════════════════════════
   EROTICSHOP — Wishlist Engine — v2.0
   ─────────────────────────────────────────────────────────────
   Tek IIFE: Core + Sync birleşik. Anonymous mode = local-only.
   Login mode = op-log + batch push + retry + login merge.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ══════════════════════════════════════════
     CONFIG
     ══════════════════════════════════════════ */
  var CFG = {
    /* v3.0: App Proxy — /apps/hesap → Vercel /api. Kimlik imzadan gelir. */
    PROXY:          '/apps/hesap/wishlist',
    STATE_KEY:      'eroticshop_wishlist',
    OPLOG_KEY:      'eroticshop_wl_oplog',
    LASTSYNC_KEY:   'eroticshop_wl_lastsync',
    USER_KEY:       'eroticshop_wl_user',
    MIGRATED_KEY:   'eroticshop_wl_migrated_v2',
    LEGACY_ADDS:    'eroticshop_wl_pending_adds',
    SYNC_GAP:       60 * 1000,
    PUSH_DEBOUNCE:  500,
    OPLOG_MAX:      200,
    SYNCED_TTL:     7 * 24 * 60 * 60 * 1000, /* 7 gün */
    RETRY_DELAYS:   [1000, 3000, 8000],
    TOAST_DURATION: 2500,
    ENRICH_BATCH:   20
  };

  /* Customer ID — anonim için boş string */
  var CUSTOMER_ID = (
    (window.__eroWlCid || '').trim() ||
    (window.Shopify && window.Shopify.customer && String(window.Shopify.customer.id)) ||
    ''
  );
  var IS_LOGGED_IN = !!CUSTOMER_ID;

  /* BroadcastChannel — cross-tab sync (modern, hızlı) */
  var BC = null;
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      BC = new BroadcastChannel('eroticshop_wishlist');
    }
  } catch (e) {}

  /* ══════════════════════════════════════════
     STORAGE HELPERS
     ══════════════════════════════════════════ */
  function lsGet(key, fallback) {
    try {
      var v = localStorage.getItem(key);
      return v ? JSON.parse(v) : fallback;
    } catch (e) { return fallback; }
  }
  function lsSet(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      /* Quota → opLog için sync=1'leri at, tekrar dene */
      if (key === CFG.OPLOG_KEY && Array.isArray(value)) {
        try {
          var trimmed = value.filter(function (o) { return o.sync === 0; });
          localStorage.setItem(key, JSON.stringify(trimmed));
          return true;
        } catch (e2) {}
      }
      return false;
    }
  }
  function lsRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  /* ══════════════════════════════════════════
     STATE — UI source of truth
     ══════════════════════════════════════════ */
  function getState() {
    var s = lsGet(CFG.STATE_KEY, []);
    return Array.isArray(s) ? s : [];
  }
  function setState(list) {
    lsSet(CFG.STATE_KEY, Array.isArray(list) ? list : []);
  }
  function isInState(productId) {
    var pid = String(productId);
    return getState().some(function (i) { return String(i.id) === pid; });
  }

  /* ══════════════════════════════════════════
     OP-LOG — sadece login mode aktif
     ══════════════════════════════════════════ */
  function opLogGet() {
    var ops = lsGet(CFG.OPLOG_KEY, []);
    return Array.isArray(ops) ? ops : [];
  }
  function opLogSet(ops) {
    /* Trim: max boyut, sync=0 öncelikli korunur */
    if (ops.length > CFG.OPLOG_MAX) {
      var unsynced = ops.filter(function (o) { return o.sync === 0; });
      var synced   = ops.filter(function (o) { return o.sync === 1; });
      var keep     = synced.slice(-Math.max(0, CFG.OPLOG_MAX - unsynced.length));
      ops = keep.concat(unsynced);
    }
    lsSet(CFG.OPLOG_KEY, ops);
  }
  function opLogAppend(op) {
    if (!IS_LOGGED_IN) return null;
    var ops = opLogGet();
    op._id  = String(Date.now()) + '_' + Math.random().toString(36).slice(2, 6);
    op.ts   = op.ts || Date.now();
    op.sync = 0;
    ops.push(op);
    opLogSet(ops);
    return op._id;
  }
  function opLogMarkSynced(opIds) {
    var set = {};
    opIds.forEach(function (id) { set[id] = true; });
    var ops = opLogGet();
    ops.forEach(function (o) { if (set[o._id]) o.sync = 1; });
    /* TTL: eski sync=1'leri agresif temizle */
    var threshold = Date.now() - CFG.SYNCED_TTL;
    ops = ops.filter(function (o) {
      return !(o.sync === 1 && o.ts < threshold);
    });
    opLogSet(ops);
  }
  function opLogClearAll() { lsRemove(CFG.OPLOG_KEY); }

  /* Yerel favori izini tamamen temizler — logout ve kullanıcı değişiminde
     çağrılır. Sunucu kopyası hesapta durur, yalnızca cihaz temizlenir. */
  function clearLocalWishlist() {
    setState([]);
    opLogClearAll();
    lsRemove(CFG.LASTSYNC_KEY);
    localStorage.setItem(CFG.USER_KEY, 'anonymous');
  }

  /* ══════════════════════════════════════════
     EVENTS & TOAST
     ══════════════════════════════════════════ */
  function fireEvent(name, detail) {
    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail }));
    } catch (e) {}
  }
  function broadcast(msg) {
    if (BC) try { BC.postMessage(msg); } catch (e) {}
  }
  var toastTimer = null;
  function showToast(msg) {
    var el = document.getElementById('wl-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, CFG.TOAST_DURATION);
  }

  /* ══════════════════════════════════════════
     PUBLIC ACTIONS — add / remove / toggle / clear
     ══════════════════════════════════════════ */
  function add(product) {
    if (!product || !product.id) return false;
    var state = getState();
    var pid   = String(product.id);
    if (state.some(function (i) { return String(i.id) === pid; })) return false;

    var item = {
      id:      pid,
      handle:  product.handle  || '',
      title:   product.title   || '',
      image:   product.image   || '',
      price:   toCents(product.price),
      compare: toCents(product.compare),
      url:     product.url     || (product.handle ? '/products/' + product.handle : ''),
      vendor:  product.vendor  || '',
      addedAt: Date.now()
    };
    state.unshift(item);
    setState(state);

    if (IS_LOGGED_IN) {
      opLogAppend({ op: 'add', pid: item.id, handle: item.handle });
      schedulePush();
    }

    fireEvent('wishlist:added', item);
    fireEvent('wishlist:changed', { list: state, action: 'add', product: item });
    broadcast({ type: 'changed' });
    showToast('Favorilere eklendi ❤️');
    return true;
  }

  function remove(productId) {
    var state = getState();
    var pid   = String(productId);
    var idx   = -1;
    for (var i = 0; i < state.length; i++) {
      if (String(state[i].id) === pid) { idx = i; break; }
    }
    if (idx === -1) return false;
    var removed = state[idx];
    state.splice(idx, 1);
    setState(state);

    if (IS_LOGGED_IN) {
      opLogAppend({ op: 'remove', pid: pid });
      schedulePush();
    }

    fireEvent('wishlist:removed', removed);
    fireEvent('wishlist:changed', { list: state, action: 'remove', product: removed });
    broadcast({ type: 'changed' });
    showToast('Favorilerden çıkarıldı');
    return true;
  }

  function toggle(product) {
    if (!product || !product.id) return false;
    if (isInState(product.id)) { remove(product.id); return false; }
    add(product); return true;
  }

  function clearAll() {
    setState([]);
    if (IS_LOGGED_IN) {
      /* Önceki bekleyen op'ları temizle, sadece "clear" op'u kalsın */
      lsRemove(CFG.OPLOG_KEY);
      opLogAppend({ op: 'clear', pid: '' });
      schedulePush();
    }
    fireEvent('wishlist:changed', { list: [], action: 'clear' });
    broadcast({ type: 'changed' });
    showToast('Favoriler temizlendi');
    syncUI();
  }

  /* ══════════════════════════════════════════
     UI SYNC — header heart + cards
     ══════════════════════════════════════════ */
  function updateHeaderHeart() {
    var count = getState().length;
    var icon  = document.getElementById('header-wishlist-icon');
    if (icon) {
      icon.classList.toggle('has-items', count > 0);
      var svg = icon.querySelector('.header__wishlist-heart');
      if (svg) svg.style.fill = count > 0 ? '#c0427b' : 'none';
      var badge = icon.querySelector('.header__wishlist-badge');
      if (badge) badge.textContent = count > 99 ? '99+' : count;
    }
    var mIcon = document.getElementById('md-wishlist-icon');
    if (mIcon) {
      var mSvg = mIcon.querySelector('svg');
      if (mSvg) {
        mSvg.style.fill   = count > 0 ? '#c0427b' : 'none';
        mSvg.style.stroke = '#c0427b';
      }
    }
  }
  function syncAllButtons() {
    var buttons = document.querySelectorAll('[data-wl-id]');
    buttons.forEach(function (btn) {
      var id     = btn.getAttribute('data-wl-id');
      var active = isInState(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  }
  function syncUI() {
    syncAllButtons();
    updateHeaderHeart();
  }

  /* ══════════════════════════════════════════
     CLICK DELEGATION
     ══════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var product = {
      id:      btn.getAttribute('data-wl-id'),
      handle:  btn.getAttribute('data-wl-handle')  || '',
      title:   btn.getAttribute('data-wl-title')   || '',
      image:   btn.getAttribute('data-wl-image')   || '',
      price:   btn.getAttribute('data-wl-price')   || '',
      compare: btn.getAttribute('data-wl-compare') || '',
      url:     btn.getAttribute('data-wl-url')     || '',
      vendor:  btn.getAttribute('data-wl-vendor')  || ''
    };
    var nowActive = toggle(product);
    btn.classList.toggle('is-active', nowActive);
    syncAllButtons();
    updateHeaderHeart();

    /* Haptic feedback (mobile) — sadece eklerken */
    if (nowActive && navigator.vibrate) {
      try { navigator.vibrate(15); } catch (e) {}
    }
  });

  /* ══════════════════════════════════════════
     CROSS-TAB SYNC
     ══════════════════════════════════════════ */
  if (BC) {
    BC.addEventListener('message', function (e) {
      if (e.data && e.data.type === 'changed') syncUI();
    });
  }
  /* Fallback: storage event (BC desteklenmeyen tarayıcılar için) */
  window.addEventListener('storage', function (e) {
    if (e.key === CFG.STATE_KEY) syncUI();
  });

  /* Header kalbi de değişim olayına abone — her yoldan (card/PDP/favori sayfası) güncellensin (alt bar ile aynı) */
  window.addEventListener('wishlist:changed', updateHeaderHeart);

  /* ══════════════════════════════════════════
     SYNC ENGINE — Login mode only
     ══════════════════════════════════════════ */
  var pushTimer    = null;
  var pushInFlight = false;
  var pushAbort    = null;

  function schedulePush() {
    if (!IS_LOGGED_IN) return;
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(flushPush, { timeout: 2000 });
      } else {
        setTimeout(flushPush, 0);
      }
    }, CFG.PUSH_DEBOUNCE);
  }

  function sleep(ms) {
    return new Promise(function (r) { setTimeout(r, ms); });
  }

  function buildBatch(ops) {
    return ops.map(function (o) {
      var b = { op: o.op, ts: o.ts };
      if (o.pid)    b.productId = o.pid;
      if (o.handle) b.handle    = o.handle;
      return b;
    });
  }

  async function pushWithRetry(ops) {
    /* v3.0: customerId gönderilmez — sunucu logged_in_customer_id kullanır */
    var body = JSON.stringify({ ops: buildBatch(ops) });

    for (var i = 0; i <= CFG.RETRY_DELAYS.length; i++) {
      if (i > 0) await sleep(CFG.RETRY_DELAYS[i - 1]);
      try {
        if (pushAbort) try { pushAbort.abort(); } catch (e) {}
        pushAbort = ('AbortController' in window) ? new AbortController() : null;
        var res = await fetch(CFG.PROXY, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    body,
          signal:  pushAbort ? pushAbort.signal : undefined,
          keepalive: true
        });
        if (res.ok) return true;
        /* 4xx → validation/yetki hatası: retry'sız sync=1 işaretle ki sonsuz retry olmasın */
        if (res.status >= 400 && res.status < 500) {
          if (window.console) console.warn('[Wishlist] Push 4xx, op iptal:', res.status);
          return true;
        }
      } catch (e) {
        /* Network error → retry */
      }
    }
    return false;
  }

  async function flushPush() {
    if (pushInFlight || !IS_LOGGED_IN) return;
    var ops = opLogGet().filter(function (o) { return o.sync === 0; });
    if (!ops.length) return;
    pushInFlight = true;
    try {
      var success = await pushWithRetry(ops);
      if (success) {
        opLogMarkSynced(ops.map(function (o) { return o._id; }));
      }
    } finally {
      pushInFlight = false;
    }
  }

  /* sendBeacon: sayfa kapanışında son şans push (mobile için kritik) */
  function beaconFlush() {
    if (!IS_LOGGED_IN) return;
    var ops = opLogGet().filter(function (o) { return o.sync === 0; });
    if (!ops.length) return;
    /* v3.0: customerId gönderilmez — kimlik App Proxy imzasından */
    var body = JSON.stringify({ ops: buildBatch(ops) });
    try {
      var sent = false;
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        sent = navigator.sendBeacon(CFG.PROXY, blob);
      }
      if (!sent) {
        /* Fallback: fetch keepalive */
        fetch(CFG.PROXY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true
        }).catch(function () {});
      }
      /* Optimistic mark synced (server'a ulaşmazsa next pull'da düzelir) */
      opLogMarkSynced(ops.map(function (o) { return o._id; }));
    } catch (e) {}
  }

  /* ══════════════════════════════════════════
     PULL — Server snapshot + unsynced ops üzerine merge
     ══════════════════════════════════════════ */
  function reduceServerWithUnsynced(serverItems, unsyncedOps) {
    var merged = serverItems.slice();
    unsyncedOps.forEach(function (op) {
      if (op.op === 'add') {
        if (!merged.some(function (i) { return String(i.id) === op.pid; })) {
          merged.unshift({ id: op.pid, handle: op.handle || '', addedAt: op.ts });
        }
      } else if (op.op === 'remove') {
        merged = merged.filter(function (i) { return String(i.id) !== op.pid; });
      } else if (op.op === 'clear') {
        merged = [];
      }
    });
    return merged;
  }

  function preserveLocalEnrichment(merged, localList) {
    var localMap = {};
    localList.forEach(function (i) { localMap[String(i.id)] = i; });
    return merged.map(function (item) {
      var l = localMap[String(item.id)];
      if (l && l.image) {
        return Object.assign({}, item, {
          title:   l.title,
          image:   l.image,
          price:   l.price,
          compare: l.compare,
          url:     l.url,
          vendor:  l.vendor
        });
      }
      return item;
    });
  }

  async function pull(force) {
    if (!IS_LOGGED_IN) return;
    var lastSync = parseInt(localStorage.getItem(CFG.LASTSYNC_KEY) || '0', 10);
    if (!force && Date.now() - lastSync < CFG.SYNC_GAP) return;

    try {
      var res = await fetch(CFG.PROXY, { method: 'GET', keepalive: true });
      if (!res.ok) return;
      var data = await res.json();
      var serverItems = Array.isArray(data.items) ? data.items : [];

      var unsynced = opLogGet().filter(function (o) { return o.sync === 0; });
      var merged   = reduceServerWithUnsynced(serverItems, unsynced);

      /* Lokal zenginlik (image/price/title) korunsun */
      merged = preserveLocalEnrichment(merged, getState());

      setState(merged);
      localStorage.setItem(CFG.LASTSYNC_KEY, String(Date.now()));
      syncUI();
      fireEvent('wishlist:changed', { list: merged, action: 'sync' });
      broadcast({ type: 'changed' });

      /* Image olmayan item'ları arka planda zenginleştir */
      enrichMissing();
    } catch (e) {}
  }

  /* Lazy enrich: image olmayan item'ları /products/X.js'den doldur */
  /* Kanonik fiyat formatı: Number (kuruş).
     Rakam-dışı / boş / legacy formatlı değerler → null → enrichMissing onarır. */
  function toCents(v) {
    if (typeof v === 'number' && isFinite(v)) return Math.round(v);
    if (typeof v === 'string' && /^\d+$/.test(v.trim())) return parseInt(v.trim(), 10);
    return null;
  }

  async function enrichMissing() {
    var current = getState();
    /* Görseli eksik VEYA fiyatı kanonik (Number) olmayan her kayıt onarılır */
    var need    = current.filter(function (i) {
      return i.handle && (!i.image || typeof i.price !== 'number');
    });
    if (!need.length) return;
    need = need.slice(0, CFG.ENRICH_BATCH);

    await Promise.all(need.map(function (item) {
      return fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image ||
            (p.images && p.images[0]
              ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src)
              : '') || '';
          /* Kanonik: .js ucu zaten kuruş döndürür — formatlamadan Number sakla */
          var price = toCents(p.price);
          var cmp   = toCents(p.compare_at_price);
          /* En güncel state'i tekrar oku — race koşulundan korun */
          var fresh = getState();
          var idx   = fresh.findIndex(function (m) { return String(m.id) === String(item.id); });
          if (idx === -1) return;
          fresh[idx] = Object.assign({}, fresh[idx], {
            title:   p.title || fresh[idx].title || '',
            image:   img,
            price:   price,
            compare: cmp,
            url:     '/products/' + (p.handle || item.handle),
            vendor:  p.vendor || ''
          });
          setState(fresh);
        }).catch(function () {});
    }));
    syncUI();
    fireEvent('wishlist:changed', { list: getState(), action: 'enrich' });
  }

  /* ══════════════════════════════════════════
     LOGIN MERGE — Anonymous → Login transition
     ══════════════════════════════════════════ */
  async function loginMergeIfNeeded() {
    var prev = localStorage.getItem(CFG.USER_KEY) || 'anonymous';
    var curr = IS_LOGGED_IN ? CUSTOMER_ID : 'anonymous';

    if (prev === curr) return;

    if (IS_LOGGED_IN) {
      /* GUARD: merge yalnızca anonim→login geçişinde yapılır.
         prev başka bir müşteri ID'siyse (A→B geçişi) kalıntı liste
         yeni hesaba SIZDIRILMAZ — atılır, sunucu snapshot esas alınır. */
      var anonState = [];
      if (prev === 'anonymous') {
        anonState = getState();
      } else {
        setState([]);
        opLogClearAll();
      }

      /* Server snapshot çek */
      var serverItems = [];
      try {
        var res = await fetch(CFG.PROXY);
        if (res.ok) {
          var data = await res.json();
          serverItems = Array.isArray(data.items) ? data.items : [];
        }
      } catch (e) {}

      /* Union merge: server kazanır, anonim'den eksik olanlar eklenir */
      var merged   = [];
      var seen     = {};
      var anonOnly = [];

      serverItems.forEach(function (item) {
        merged.push(item);
        seen[String(item.id)] = true;
      });
      anonState.forEach(function (item) {
        if (!seen[String(item.id)]) {
          merged.push(item);
          anonOnly.push(item);
        }
      });

      /* Lokal zenginliği geri yansıt */
      merged = preserveLocalEnrichment(merged, anonState);

      setState(merged);
      localStorage.setItem(CFG.USER_KEY, curr);
      localStorage.setItem(CFG.LASTSYNC_KEY, String(Date.now()));

      /* Anon-only item'ları opLog'a yaz, push'a gönder */
      anonOnly.forEach(function (item) {
        opLogAppend({
          op: 'add',
          pid: String(item.id),
          handle: item.handle || ''
        });
      });

      syncUI();
      fireEvent('wishlist:changed', { list: merged, action: 'merge' });
      broadcast({ type: 'changed' });

      if (anonOnly.length) schedulePush();

      /* Merge sonrası zenginleştirme hemen başlar. pull() SYNC_GAP
         nedeniyle atlandığından enrich tetiklenmiyor, Favorilerim
         "boş çerçeve" render ediyordu. */
      enrichMissing();
    } else {
      /* Logout: yerel state temizlenir (paylaşılan cihaz gizliliği).
         Sunucu kopyası müşteri hesabında korunur. */
      clearLocalWishlist();
      syncUI();
      fireEvent('wishlist:changed', { list: [], action: 'logout' });
      broadcast({ type: 'changed' });
    }
  }

  /* ══════════════════════════════════════════
     MIGRATION — v1 → v2 (tek seferlik)
     ══════════════════════════════════════════ */
  function migrate() {
    if (localStorage.getItem(CFG.MIGRATED_KEY)) return;

    /* Eski pending_adds → opLog'a aktar */
    var legacy = lsGet(CFG.LEGACY_ADDS, []);
    if (Array.isArray(legacy) && legacy.length && IS_LOGGED_IN) {
      legacy.forEach(function (p) {
        if (p && p.productId) {
          opLogAppend({
            op: 'add',
            pid: String(p.productId),
            handle: (p.handle || (p.item && p.item.handle) || '')
          });
        }
      });
    }
    lsRemove(CFG.LEGACY_ADDS);
    localStorage.setItem(CFG.MIGRATED_KEY, '1');
  }

  /* ══════════════════════════════════════════
     INIT
     ══════════════════════════════════════════ */
  async function init() {
    migrate();
    syncUI();

    if (IS_LOGGED_IN) {
      await loginMergeIfNeeded();
      pull();
      schedulePush();
    } else {
      var prev = localStorage.getItem(CFG.USER_KEY);
      if (prev && prev !== 'anonymous') {
        /* Çıkış tespit edildi: yerel favoriler temizlenir, tüm sekmeler
           BroadcastChannel ile senkronlanır. Kalp/sayaç anında sıfırlanır. */
        clearLocalWishlist();
        syncUI();
        fireEvent('wishlist:changed', { list: [], action: 'logout' });
        broadcast({ type: 'changed' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Visibility resume → 60s+ uzaklaşmışsa pull + push */
  var hiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      hiddenAt = Date.now();
    } else if (hiddenAt && IS_LOGGED_IN) {
      var elapsed = Date.now() - hiddenAt;
      if (elapsed >= CFG.SYNC_GAP) pull(true);
      schedulePush();
    }
  });

  /* Pagehide → sendBeacon flush (mobile Safari/iOS için kritik) */
  window.addEventListener('pagehide', beaconFlush);

  /* Page show + persisted (back/forward cache) */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncUI();
  });

  /* ══════════════════════════════════════════
     PUBLIC API — window.EroticWishlist (v1 ile uyumlu)
     ══════════════════════════════════════════ */
  window.EroticWishlist = {
    get:        getState,
    add:        add,
    remove:     remove,
    toggle:     toggle,
    has:        isInState,
    count:      function () { return getState().length; },
    clear:      clearAll,
    sync:       syncUI,
    customerId: CUSTOMER_ID,
    /* v3 introspection (debug / admin için) */
    _v:         '3.0',
    _opLog:     opLogGet,
    _flush:     flushPush,
    _pull:      pull
  };

})();
